import * as React from 'react'
import { useShowContext, SimpleShowLayout, Show, useTranslate, Loading, Error } from 'react-admin'
import { Grid, Container } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { ShowListElement } from 'src/components/uiElements/CRUD/ShowListElement'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'

const ShowWrapper = ({ children }) => <Container maxWidth='false'> {children}</Container>

const ShowContent = () => {
  const translate = useTranslate()
  const {
    error, // error returned by dataProvider when it failed to fetch the record. Useful if you want to adapt the view instead of just showing a notification using the `onError` side effect.
    isLoading, // boolean that is true until the record is available for the first time
    record, // record fetched via dataProvider.getOne() based on the id from the location
  } = useShowContext()

  if (isLoading) {
    return <Loading />
  }

  if (error) {
    return <Error />
  }

  return (
    <SimpleShowLayout>
      <CardCommon
        title={translate('ra.single_entity.cash')}
        actions={<CardCrudBottomButtons btnEdit={true} />}
      >
        <Grid container spacing={3}>
          <ShowListElement label={'ID'} value={record.id} />
          <ShowListElement label={translate('ra.field.name')} value={record.name} />
          <ShowListElement label={translate('ra.field.code')} value={record.code} />
          <ShowListElement label={translate('ra.field.journal')} value={record.journal} />
          <ShowListElement label={translate('ra.field.account_number')} value={record?.account_number} />
          <ShowListElement label={translate('ra.field.work_unit')} value={record.work_unit?.long_name} />
          <ShowListElement type='boolean' label={translate('ra.field.is_conciliable')} value={record.is_conciliable} />
          <ShowListElement type='boolean' label={translate('ra.field.is_private')} value={record.is_private} />
        </Grid>
      </CardCommon>
    </SimpleShowLayout>
  )
}

export const BankShow = (props) => {
  return (
    <Show component={ShowWrapper} {...props} className='CrudShowContainer' actions={null}>
      <ShowContent {...props} />
    </Show>
  )
}
